module.exports = __webpack_public_path__ + "static/img/blog7.030fe4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog7.jpg
// module id = FB6q
// module chunks = 0